import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class RepeatsColumn extends Column {
    title = 'training.repeats';
    property = 'trainingProgram.recurrenceLabel';
    sortable = false;
    type: CellDisplay = CellDisplay.string;
}
